export default __webpack_public_path__ + "static/media/powered-by-stripe.366e2f13.png";